import { css } from '@emotion/react';
import t from 'react-translate';
import NvIcon from 'shared/components/nv-icon';
import prodPathReplace from 'shared/prod-path-rewrite';
import { quarterSpacing, standardSpacing } from 'styles/global_defaults/scaffolding';

const styles = css`
  border-radius: ${quarterSpacing}px;

  .participant-experience-image img {
    max-width: 150px;
    border-radius: ${standardSpacing}px;
  }
`;

const ParticipantExperience = () => {
  const translationBase = t.MENTORING_PROGRAMS.SETTINGS.TABS.GUIDANCE.PARTICIPANT_EXPERIENCE;

  return (
    <div css={styles} className='d-flex w-100 align-items-center p-3 mb-4 bg-color-blue-05'>
      <NvIcon icon='ideas' size='small' className='mr-2 color-primary' />
      <div className='mr-2 black'>
        {translationBase.DESCRIPTION()}
      </div>
      <div className='participant-experience-image'>
        <img
          src={prodPathReplace('images/planning-first-meeting.gif')}
          alt={translationBase.ALT_LABEL()}
        />
      </div>
    </div>
  );
};

export default ParticipantExperience;
